module.exports = __webpack_public_path__ + "img/logo.bec52cf5.png";